import React from 'react';
import HighlightsCard from '../HighlightsCard';
import { useTileData } from '../../../hooks/useTileData';
import { getCdpKpis } from '../../../api';
import { fmtNumber } from '../../shared/format';

export default function VisitorsHighlight({ clientId, rangeStart, rangeEnd }) {
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getCdpKpis(clientId, rangeStart, rangeEnd);
      return resp?.data ?? null;
    },
    [clientId, rangeStart, rangeEnd],
    Boolean(clientId && rangeStart && rangeEnd),
  );

  const cur = data?.current;
  const prev = data?.previous;
  const visitors = Number(cur?.total_visitors ?? 0);
  const prevVisitors = Number(prev?.total_visitors ?? 0);
  const known = Number(cur?.known_people ?? 0);
  const knownPct = visitors > 0 ? (known / visitors) * 100 : null;
  const delta = prevVisitors > 0 ? ((visitors - prevVisitors) / prevVisitors) * 100 : null;

  const caption = knownPct != null && known > 0
    ? `${knownPct.toFixed(0)}% identified`
    : null;

  return (
    <HighlightsCard
      label="Visitors"
      value={fmtNumber(visitors)}
      delta={delta}
      caption={caption}
      loading={loading}
      error={error}
    />
  );
}
